module.exports = "/images/MS.png?eb3be066f16c568c9639199831fcebca";